import { call, put } from 'redux-saga/effects';
import { getInstance } from 'util/i18n';
import { logout } from 'actions/shellActions';
import { ApiError } from 'api/fetch';
import { TranslationFunction } from 'i18next';

export type TranslateErrorResult = {
    localError: Error;
    invalidSession: boolean;
};

export function translateError(error: Error, t: TranslationFunction): TranslateErrorResult {
    // We assume that spaces indicates it's a client-side error... so skip translation.
    if (typeof error.message === 'string' && error.message.indexOf(' ') > 0) {
        return {
            localError: error,
            invalidSession: false,
        };
    }

    const localMessage = t(error.message);
    if (localMessage === error.message) {
        return {
            localError: error,
            invalidSession: false,
        };
    }

    const localError = new Error(localMessage);
    const invalidSession = !!(error as ApiError).isSessionInvalid;

    return {
        localError,
        invalidSession,
    };
}

export function* handleErrorSaga<T extends (e: Error, m?: M) => { type: string }, M = void>(error: Error, actionCreator: T, meta?: M) {
    let i18n: { t: TranslationFunction };
    try {
        i18n = yield call(getInstance);
    }
    catch (ignored) {
        yield call([ console, 'error' ], 'Received error before i18n loaded', error);
        yield put(actionCreator(error, meta)); // report the untranslated message
        return;
    }

    // For some reason, i18n.t loses its 'this' context... so put it back in.
    const t: TranslationFunction = (key: string) => i18n.t.call(i18n, key);
    
    const { localError, invalidSession } = yield call(translateError, error, t);
   
    yield call([ console, 'error' ], localError);
    yield put(actionCreator(localError, meta));

    // Logout if this error was about an expired session
    if (invalidSession) {
        yield put(logout());
    }
}



// WEBPACK FOOTER //
// ./src/sagas/app/handleError.ts